<template>
  <div class="widget-boxed padd-bot-0">
    <div class="widget-boxed-header br-0">
      <h4>{{ title }} <a :href="'#' + id" data-toggle="collapse"><i class="pull-right ti-plus" aria-hidden="true"></i></a></h4>
    </div>
    <div class="widget-boxed-body collapse" :id="id">
      <div class="side-list no-border">
        <ul>
          <li v-if="filter">
            <input type="text" class="form-control" v-model="keyword" :placeholder="$t('jobs.filter')">
          </li>
          <li v-for="c in clist">
            <span class="custom-checkbox">
              <input type="checkbox" :id="id + c.id" :value="c.id" :checked="checked(c.id)" @change="updateValue($event.target.value)">
              <label :for="id + c.id" v-if="$i18n.locale === 'zh'">
              {{ c.c_fullname ? c.c_fullname : c.c_name }}
              </label>
              <label :for="id + c.id" v-else>
              {{ c.e_fullname ? c.e_fullname : c.e_name }}
              </label>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SearchBox',
  model: {
    prop: 'values',
    event: 'change'
  },
  props: ['id', 'title', 'criteria', 'values', 'filter'],
  data: () => ({
  keyword: null
  }),
  computed: {
    clist: function() {
      let k = this.keyword ? this.keyword.toLowerCase() : ''
      if (!this.criteria) return []
      return this.criteria.filter(item => {
    if ((item.c_fullname && item.c_fullname.toLowerCase().includes(k)) || (item.e_fullname && item.e_fullname.toLowerCase().includes(k)) || (item.c_name && item.c_name.toString().includes(k)) || (item.e_name && item.e_name.toString().includes(k))) {
      return item
    }
    })
    }
  },
  methods: {
    checked: function(id) {
      //console.log(this.values + ' === ' + id)
      return this.values.indexOf(id.toString()) != -1 || this.values.indexOf(id) != -1
    },
    updateValue: function(val) {
      let index = this.values.indexOf(val)
      if (index != -1)
        this.values.splice(index, 1)
      else
        this.values.push(val)

      this.$emit('update:values', this.values)
    }
  }
}
</script>